const initialState = () => {
    return {
        /**
         * @description
         * This variable contains data about a sale made in 
         * sale area that it's sended to CashDesk
         */
        saleDetail:null,
        saleDetailEmployee:null,
        subtotalTicket:0,
        subtotalInvoice:0,
        iva:0,
        total:0,
        totalInvoice:0,
        netTotal:0,
        excentTotal:0,
        customerId:null,
        posSaleType:null,

        ticketCode: '',
        payment:'',
        paymentMethod:null,
        lastPaymentMethod:null,
        paymentDetail:null,
        arrayPayments:[],

        paymentMethodsList: [
            { text: 'Efectivo', id: 1 },
            { text: 'Débito', id: 2 },
            { text: 'Crédito', id: 3 },
            { text: 'Cheque', id: 4 },
        ],
        payer:null,
        discountOrChargePercentage:0,
        oc: '',

        banks: [],
        // // data related to transbank payment method:
        // voucher:null,
        // // data related to check payment method:
        // checkType:null,
        // rutCheck:null,
        // nameCheck:null,
        // releaseDateCheck:null,
        // chargeDateCheck:null,
        seller: {},
        cashier: {},
        invoiceObservation: '',
        multipleSaleTicket : [],
        isChangeTicket : false,
        switchMultipleTicket: false,
    }
}

export default initialState
